import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(postObject: Request): Promise<Optional<string>> {
	const url = `${SERVICEBASEURL.USER}/IdentityProvider/`;
	return axios.post(url, postObject).toOptionalMapped((x) => x.data);
}

export interface Request {
	clientId: string;
	name: string;
	clientAuthenticationRequired: boolean;
	clientSecret: string;
	openIdConnectDiscoveryUrl: string;
	propagateLogout: boolean;
	useRefreshTokenForLogout: boolean;
	mapRoles: boolean;
	roleJsonPath: string;
	iconSvgId: string | null;
	sortOrder: number;
}

export interface Response {
	data: string;
}
